import React, { useState } from "react";
import { FaUser } from "react-icons/fa";
import "./search-tabs.scss";
import { Link } from "react-router-dom";
import ComingSoonPopup from "../../ui/commons/ComingSoonPopup";

const SearchTabs = () => {
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);

  const increment = (setter, value) => setter(value + 1);
  const decrement = (setter, value) => {
    if (value > 0) setter(value - 1);
  };

  const [isOpen, setIsOpen] = useState(false);

  function closeCommingSoonPopup() {
    setIsOpen(false);
  }

  return (
    <section className="search-tabs-section-dark">
      <div className="container">
        <div className="search-tabs-wrapper container">
          {/* Bootstrap Nav Tabs */}
          <ul className="nav nav-tabs search-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="esim-tab"
                data-bs-toggle="tab"
                data-bs-target="#esim"
                type="button"
                role="tab"
                aria-controls="esim"
                aria-selected="false"
              >
                <img src="/images/icons/simcard.svg" alt="icon" /> eSim
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <Link to="/flights" className="nav-link" id="flights-tab">
                <img src="/images/icons/flights.svg" alt="icon" /> Flights
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link
                to="/hotels"
                className="nav-link"
                id="hotels-tab"
                onClick={(e) => {
                  e.preventDefault();

                  setIsOpen(true);
                }}
              >
                <img src="/images/icons/hotels.svg" alt="icon" /> Hotels
              </Link>
            </li>
          </ul>

          {/* Tab Content */}

          {/* Passenger Modal */}
          <div
            className="modal fade"
            id="passengerModal"
            tabIndex="-1"
            aria-labelledby="passengerModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content passenger-modal">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <FaUser /> 1 Adult, Economy
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="passenger-box">
                    <h6 className="instruction">
                      Please select the exact number of passengers to view the
                      best prices
                    </h6>

                    {/* Adults */}
                    <div className="passenger-row">
                      <div>
                        <strong>Adults</strong>
                        <br />
                        <small>12+ years old</small>
                      </div>
                      <div className="quantity-box">
                        <button
                          type="button"
                          className="qty-btn minus"
                          onClick={() => decrement(setAdults, adults)}
                        >
                          -
                        </button>
                        <span className="qty-count">{adults}</span>
                        <button
                          type="button"
                          className="qty-btn plus"
                          onClick={() => increment(setAdults, adults)}
                        >
                          +
                        </button>
                      </div>
                    </div>

                    {/* Children */}
                    <div className="passenger-row">
                      <div>
                        <strong>Children</strong>
                        <br />
                        <small>2-11 years old</small>
                      </div>
                      <div className="quantity-box">
                        <button
                          type="button"
                          className="qty-btn minus"
                          onClick={() => decrement(setChildren, children)}
                        >
                          -
                        </button>
                        <span className="qty-count">{children}</span>
                        <button
                          type="button"
                          className="qty-btn plus"
                          onClick={() => increment(setChildren, children)}
                        >
                          +
                        </button>
                      </div>
                    </div>

                    {/* Infants */}
                    <div className="passenger-row">
                      <div>
                        <strong>Infants on lap</strong>
                        <br />
                        <small>Under 2 years old</small>
                      </div>
                      <div className="quantity-box">
                        <button
                          type="button"
                          className="qty-btn minus"
                          onClick={() => decrement(setInfants, infants)}
                        >
                          -
                        </button>
                        <span className="qty-count">{infants}</span>
                        <button
                          type="button"
                          className="qty-btn plus"
                          onClick={() => increment(setInfants, infants)}
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <select className="form-select mb-3">
                      <option>Economy</option>
                      <option>Economy / Premium economy</option>
                      <option>Premium Economy</option>
                      <option>First / Business</option>
                      <option>Business</option>
                      <option>First</option>
                    </select>

                    <button className="btn confirm-btn w-100">Confirm</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ComingSoonPopup
        isOpen={isOpen}
        onOk={closeCommingSoonPopup}
        onCancel={closeCommingSoonPopup}
      />
    </section>
  );
};

export default SearchTabs;
